import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from 'APP/wsApi/wsAppApi/WsAppApi';
import { GetStorageSessionRequestSchema } from 'APP/wsApi/wsAppApi/types/upload/upload_requests_pb';
import { GetStorageSessionResponse } from 'APP/wsApi/wsAppApi/types/upload/upload_responses_pb';

export function getFileStorageSessionCredentialsRequest(): Promise<GetStorageSessionResponse> {
  return wsAppRequestManager.request<GetStorageSessionResponse>({
    case: 'getStorageSession',
    value: create(GetStorageSessionRequestSchema, {}),
  });
}
